import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useForm } from "../../hooks/useForm";
import { buscarParticipante } from "../../utils/Datos";

export const BuscarParticipante = ({
  setParticipante,
  setCargando,
  idProcess,
  limpiar,
}) => {
  const [{ busqueda }, handleInputChange, resetForm] = useForm({
    busqueda: "",
  });

  useEffect(() => {
    resetForm();
  }, [limpiar]);

  const handleSubmit = () => {
    setCargando(true);
    buscarParticipante(busqueda, idProcess).then((datos) => {
      setCargando(false);
      console.log('como vienen los datos',datos);
      if (datos.status === true) {
        console.log("DATOS PARTICIPANTE");
        console.log(datos.datos);
        setParticipante(datos.datos);
        resetForm();
      } else {
        Swal.fire({
          title: "Error",
          text: datos.errores ?? "Ocurrió un error",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    });
  };

  return (
    <div className="mb-4">
      <h4>Buscar Participante</h4>
      <div className="input-group mb-5">
        <input
          className="form-control"
          placeholder="Buscar por rut"
          aria-label="buscar"
          aria-describedby="buscar"
          type="text"
          name="busqueda"
          value={busqueda}
          onChange={handleInputChange}
        />
        <span className="input-group-text" onClick={handleSubmit}>
          <i className="fas fa-search"></i>
        </span>
      </div>
    </div>
  );
};
